import { z } from "zod";

import { StoredTargetRatiosSchema } from "./target-ratios.js";

/** One slot when the order stored no target ratios. Not itself a TargetRatio. */
export const DEFAULT_THUMBNAIL_SLOT = "default" as const;

/** JPG, PNG, and WebP partner thumbnails. */
export const PARTNER_THUMBNAIL_MAX_BYTES = 5 * 1024 * 1024;

export const ThumbnailSlotSchema = z.union([
  z.enum(["16:9", "9:16", "4:5", "1:1"]),
  z.literal(DEFAULT_THUMBNAIL_SLOT),
]);

export type ThumbnailSlot = z.infer<typeof ThumbnailSlotSchema>;

/**
 * Slots a partner may fill for this order. Known ratios stay in canonical
 * order. An empty or unknown list is one default slot — Postgres unique
 * constraints allow many nulls, so the sentinel is a real value.
 */
export function thumbnailSlotsForTargetRatios(
  ratios: readonly string[] | null | undefined,
): ThumbnailSlot[] {
  const parsed = StoredTargetRatiosSchema.parse(ratios ?? []);
  if (parsed.length === 0) return [DEFAULT_THUMBNAIL_SLOT];
  return parsed;
}
